import { Add as IconAdd, AddLocationAlt as IconAddLocationAlt } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { AreaCardVisitItem } from "~/modules/plannerV2/components/AreaCard";

import { GaiaExpandableMapMarkerAreaBodyFragment } from "./fragments.generated";
import { GaiaExpandableMapMarkerAreaBodySectionHeader } from "./GaiaExpandableMapMarkerAreaBodySectionHeader";

type GaiaExpandableMapMarkerAreaBodyAddVisitSectionProps = {
    visits: GaiaExpandableMapMarkerAreaBodyFragment["combinable"];
    onVisitAdd: (timeslotId: string, visitId: string) => void;
    disabled?: boolean;
};

export function GaiaExpandableMapMarkerAreaBodyAddVisitSection({
    visits,
    onVisitAdd,
    disabled = false,
}: GaiaExpandableMapMarkerAreaBodyAddVisitSectionProps) {
    const { t } = useTranslation("plannerV2");

    if (visits.length === 0) return null;

    return (
        <>
            <GaiaExpandableMapMarkerAreaBodySectionHeader
                icon={<IconAddLocationAlt />}
                title={t("gaiaExpandableMapMarkerArea.addVisitForCarpool")}
            />
            <Stack>
                {visits.map(visit => {
                    const handleClick = () => {
                        if (disabled) return;
                        onVisitAdd?.(visit.timeslotId, visit.plannerVisit.id);
                    };

                    return (
                        <AreaCardVisitItem
                            onClick={handleClick}
                            key={visit.plannerVisit.id}
                            visit={visit.plannerVisit}
                            icon={<IconAdd />}
                            disabled={disabled}
                        />
                    );
                })}
            </Stack>
        </>
    );
}
